import WebFont from 'webfontloader'

export function useGoogleFonts() {
  const loadFonts = (fonts: string[]) => {
    if (!fonts || fonts.length === 0) return

    return new Promise((resolve, reject) => {
      WebFont.load({
        google: {
          families: fonts,
          display: 'swap',
        },
        active: () => resolve(true),
        inactive: () => reject(new Error('Failed to load fonts')),
      })
    })
  }

  const extractUniqueFonts = (settings: any): string[] => {
    const fonts = new Set<string>()

    // Extract primary CTA font if it exists
    if (settings.primaryCTA?.typography?.fontFamily) {
      const ctaFont = settings.primaryCTA.typography.fontFamily
        .split(',')[0]
        .trim()
      if (!isSystemFont(ctaFont)) {
        fonts.add(ctaFont)
      }
    }

    // Extract secondary CTA font if it exists
    if (settings.secondaryCTA?.typography?.fontFamily) {
      const ctaFont = settings.secondaryCTA.typography.fontFamily
        .split(',')[0]
        .trim()
      if (!isSystemFont(ctaFont)) {
        fonts.add(ctaFont)
      }
    }

    return Array.from(fonts)
  }

  const isSystemFont = (font: string): boolean => {
    const systemFonts = [
      'Arial',
      'Helvetica',
      'Times New Roman',
      'Times',
      'Courier New',
      'Courier',
      'Verdana',
      'Georgia',
      'system-ui',
      '-apple-system',
    ]
    return systemFonts.some(systemFont =>
      font.toLowerCase().includes(systemFont.toLowerCase()),
    )
  }

  return {
    loadFonts,
    extractUniqueFonts,
  }
}
